function setTotalHeaderHeightVariable() {
  const headerElements = document.querySelectorAll('.shopify-section-group-header-group');
  let totalHeight = 0;

  headerElements.forEach((el) => {
    const style = getComputedStyle(el);
    const marginTop = parseFloat(style.marginTop) || 0;
    const marginBottom = parseFloat(style.marginBottom) || 0;
    totalHeight += el.offsetHeight + marginTop + marginBottom;
  });

  document.documentElement.style.setProperty('--total-header-height', `${totalHeight}px`);
}

// Appliquer dès que possible
document.addEventListener('DOMContentLoaded', setTotalHeaderHeightVariable);
window.addEventListener('resize', setTotalHeaderHeightVariable);
